export default __webpack_public_path__ + "static/media/mail.07447554.svg";